import * as React from "react";
import Link from "next/link";
import {
  fetchDocumentLists,
  IDocumentLists,
} from "@nju/data-access-portal-documents";
import { isOk } from "@nju/result";
import { portalRoutes, salesRoutes } from "@nju/routes";
import { IScope } from "@nju/scope";
import { A, Heading, Loader, Text } from "@nju/ui";

interface IDocumentListsProps {
  validity: "EFFECTIVE" | "EXPIRED";
  title: string;
  variant?: IScope;
}

export function DocumentLists({
  validity,
  title,
  variant = "portal",
}: IDocumentListsProps) {
  const [state, set] = React.useState<"IDLE" | "LOADING" | "ERROR" | "DONE">(
    "IDLE",
  );
  const [data, setData] = React.useState<IDocumentLists[]>([]);
  const redirectArchiveUrl =
    variant !== "sales"
      ? portalRoutes.regulaminyCennikiArchiwalne.get()
      : salesRoutes.regulaminyCennikiArchiwalne.get();

  const redirectActualUrl =
    variant !== "sales"
      ? portalRoutes.regulaminyCenniki.get()
      : salesRoutes.regulaminyCenniki.get();

  React.useEffect(() => {
    set("LOADING");

    fetchDocumentLists({ validity }).then((result) => {
      if (isOk(result)) {
        setData(result.value);
        return set("DONE");
      }

      return set("ERROR");
    });
  }, [validity]);

  if (state === "IDLE" || state === "LOADING") {
    return <Loader className="absolute left-1/2" />;
  }

  if (state === "DONE") {
    return (
      <div className="flex flex-col gap-1">
        <div className="mb-5">
          <Heading font="ttfirs" tone="neutral" variant="h2">
            {title}
          </Heading>
        </div>
        <div className="flex flex-col space-y-10 mb-5">
          {data.map((category) => {
            return (
              <div key={category.categoryId}>
                <Heading font="ttfirs" tone="neutral" variant="h3">
                  {category.categoryName.pl}
                </Heading>
                <div className="prose">
                  <ul>
                    {category.documents.map((document) => {
                      return (
                        <li key={document.title.pl}>
                          <Link
                            className="text-size-16 from-tablet:text-size-20 underline"
                            href={`https://nju.pl/dokumenty/${document.fileName}`}
                            key={document.title.pl}
                            rel="noreferrer"
                            target="_blank"
                          >
                            {document.title.pl}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
        <Link
          href={validity !== "EXPIRED" ? redirectArchiveUrl : redirectActualUrl}
          passHref={true}
        >
          <A
            className="flex justify-center underline"
            size="inline"
            variant="neutral"
          >
            <Text>
              zobacz {validity !== "EXPIRED" ? "archiwalne" : "aktualne"}{" "}
              regulaminy i cenniki
            </Text>
          </A>
        </Link>
      </div>
    );
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
